import { render, staticRenderFns } from "./LogTableView.vue?vue&type=template&id=68bdb7e6&scoped=true&"
import script from "./LogTableView.vue?vue&type=script&lang=js&"
export * from "./LogTableView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bdb7e6",
  null
  
)

export default component.exports